/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { NgModule } from '@angular/core';
import { BuilderSharedModule } from '@gh/builder-shared';
import { BuilderSetupBaseDesignRoutingModule } from './builder-setup-base-design-routing.module';
import { BaseDesignListComponent } from './components/base-design-list/base-design-list.component';
import { BaseDesignDetailsComponent } from './components/base-design-details/base-design-details.component';
import { BaseDesignBusinessService } from './resources';

@NgModule({
imports: [
  BuilderSharedModule.forChild(),
  BuilderSetupBaseDesignRoutingModule,
],
  providers: [
    BaseDesignBusinessService,
  ],
  declarations: [
    BaseDesignListComponent,
    BaseDesignDetailsComponent,
  ],
})
export class BuilderSetupBaseDesignModule {
}
